import { useCallback, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import _ from "lodash"
import { CardMedia, Typography, useTheme, Box, Button } from "@mui/material"
import TrainIcon from "@mui/icons-material/Train"

import { PageCard, PageCardContent } from "components/card"
import { AppNavigation } from "containers/AppNavigation"
import { NavigationControl } from "components/kioskHorizontal/navigation"
import { MotionDiv } from "components/motions"
import { useTranslation } from "providers/i18n"
import { QRCode } from "components/QRCode"
import { useExtension } from "hooks/extension/useExtension"
import { useBtsDetail } from "extensions/em-transportation/hooks/useBtsDetail"
import { TransportationImageModal } from "extensions/em-transportation/components/TransportationImageModal"

export const EmBtsTransportationKioskHPage = ({ Layout = Box }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const theme = useTheme()
  const { extensionConfig } = useExtension()

  const { styleOverrides: bannerStyleOverrides = {} } =
    theme.components[`AppBanner`] || {}
  const sideBarStyleOverrides =
    theme.components[`AppSidebar`]?.styleOverrides || {}
  const { root: bannerRoot } = bannerStyleOverrides
  const { wrapper, body, footer } = sideBarStyleOverrides

  const styleOverrides =
    theme.components[`EmBtsTransportationPage`]?.styleOverrides || {}
  const {
    root,
    pageCardContent,
    title,
    cardMedia,
    button,
    buttonWrapper,
    mapButton,
  } = styleOverrides

  const { styleOverrides: emTransportationPageStyleOverrides = {} } =
    theme.components[`EmTransportationPage`] || {}

  const { qrCode } = emTransportationPageStyleOverrides

  const btsConfig = useMemo(
    () => _.get(extensionConfig, "em-transportation.options"),
    [extensionConfig]
  )

  const btsLocationLinks = useMemo(
    () => _.get(btsConfig, "bts.locations", []),
    [btsConfig]
  )

  const {
    locationLinks,
    mobileUrl,
    openImageModalState,
    openImageModal,
    closeImageModal,
  } = useBtsDetail(btsLocationLinks)

  const onClickBtsLocation = useCallback(
    (id) => {
      navigate(`/maps/place/${id}`)
    },
    [navigate]
  )

  const btsImage = useMemo(() => _.get(theme, "assets.bts.url"), [theme])
  const btsMapImage = useMemo(() => _.get(theme, "assets.btsMap.url"), [theme])

  return (
    <>
      <Layout
        aside={
          <PageCard>
            <Box sx={wrapper}>
              <Box sx={bannerRoot}></Box>
              <Box sx={body}>
                <AppNavigation />
              </Box>
              <Box sx={footer}>
                <NavigationControl />
              </Box>
            </Box>
          </PageCard>
        }
      >
        <PageCard sx={root}>
          <MotionDiv
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.15 }}
          >
            <PageCardContent sx={pageCardContent}>
              <Typography variant="h1" component="h1" sx={title}>
                Bts SKYTRAIN : PHROM PHONG
              </Typography>
              <CardMedia component="img" image={btsImage} sx={cardMedia} />
              <Button
                size="small"
                variant="text"
                sx={mapButton}
                onClick={openImageModal}
              >
                CLICK TO SEE BTS SKYTRAIN ROUTE MAP
              </Button>

              <QRCode
                sx={qrCode}
                caption={t("Send to Mobile")}
                url={mobileUrl}
              />
              <Box sx={buttonWrapper}>
                {locationLinks.length > 0 &&
                  locationLinks.map((data) => {
                    const { id, name, location } = data
                    return (
                      <Button
                        key={id}
                        variant="contained"
                        startIcon={<TrainIcon />}
                        sx={button}
                        onClick={() => onClickBtsLocation(location?.id)}
                      >
                        {t(name)}
                      </Button>
                    )
                  })}
              </Box>
            </PageCardContent>
          </MotionDiv>
        </PageCard>
      </Layout>
      <TransportationImageModal
        open={openImageModalState}
        onClose={closeImageModal}
        imageSrc={btsMapImage}
      />
    </>
  )
}
